import { apiClient } from '../../utils';
import { handleError } from '../';

export const toSitePost = async ({
  siteService,
  pi,
  siteId,
  userSiteFilters,
  ...rest
}) => {
  try {
    const result = await apiClient.post(`/postChain/toSitePost`, {
      data: {
        ...rest,
        ...(siteService ? { siteService } : {}),
        pci: pi,
        site: siteId,
        filters: userSiteFilters,
      },
    });
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
